import {markInputRule} from "../helper/prosemirrorInputRules";
import {toggleMark} from "prosemirror-commands";
import AbstractMark from "./AbstractMark";

export default class Strikethrough extends AbstractMark {
    get name() {
        return "strikethrough";
    }

    get schema() {
        return {
            parseDOM: [{tag: "s"}, {tag: "del"}, {tag: "strike"}, {
                style: "text-decoration", getAttrs: value => value === "line-through"
            }],
            toDOM: () => ["s", 0]
        }
    }

    get markdownToken() {
        return "s";
    }

    get toMarkdown() {
        return {
            open: "~~",
            close: "~~",
            mixable: true,
            expelEnclosingWhitespace: true
        }
    }

    get parseMarkdown() {
        return {
            mark: "strikethrough"
        }
    }

    inputRules({type}) {
        return [markInputRule(/(?:^|[^~\\]+)(~~([^~]+)~~)$/, type)];
    }

    keys({type}) {
        return {
            "Mod-d": toggleMark(type),
            "Mod-D": toggleMark(type)
        };
    }
}